import { getBlogByIdUser } from '../../util/api';

// ================ Action types ================ //

export const GET_BLOG_REQUEST = 'app/PostPage/GET_BLOG_REQUEST';
export const GET_BLOG_SUCCESS = 'app/PostPage/GET_BLOG_SUCCESS';
export const GET_BLOG_ERROR = 'app/PostPage/GET_BLOG_ERROR';

// ================ Reducer ================ //

const initialState = {
  getBlogInProgress: false,
  getBlogError: null,
  blog: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_BLOG_REQUEST:
      return { ...state, getBlogInProgress: true, getBlogError: null };
    case GET_BLOG_SUCCESS:
      return { ...state, getBlogInProgress: false, blog: payload };
    case GET_BLOG_ERROR:
      return { ...state, getBlogInProgress: false, getBlogError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const getBlogRequest = () => ({ type: GET_BLOG_REQUEST });
export const getBlogSuccess = blog => ({
  type: GET_BLOG_SUCCESS,
  payload: blog,
});
export const getBlogError = e => ({
  type: GET_BLOG_ERROR,
  payload: e,
  error: true,
});

// ================ Thunks ================ //

export const fetchBlogById = (params) => async (dispatch, getState, sdk) => {
  dispatch(getBlogRequest());
  try {
    const res = await getBlogByIdUser({ slug: params.slug });
    dispatch(getBlogSuccess(res?.data));
  } catch (error) {
    console.error('Error fetching blog:', error);
    dispatch(getBlogError(error));
  }
};

export const loadData = (params, search, config) => (dispatch, getState) => {
  return dispatch(fetchBlogById(params));
};
